// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { appReducer } from 'store/behaviors/loader';
import capabilities from './capabilities';
import initialState from './grid';

const slice = createSlice({
    name: 'businessOpportunity',
    initialState,
    reducers: {
        ...appReducer(capabilities),
        insertTasks(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, tasks } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item) return;

            item.tasks = [...(Array.isArray(item.tasks) ? item.tasks : []), ...[].concat(tasks || [])];
        },
        updateTasks(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, tasks } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item) return;

            if (!Array.isArray(item.tasks)) {
                item.tasks = [];
            }

            [].concat(tasks || []).forEach((updTask) => {
                if (!updTask?.id) return;

                const taskIndex = item.tasks.findIndex((task) => task.id === updTask.id);

                if (taskIndex === -1) {
                    item.tasks.push(updTask);
                } else {
                    item.tasks[taskIndex] = {
                        ...item.tasks[taskIndex],
                        ...updTask
                    };
                }
            });
        },
        deleteTasks(state, action) {
            if (!Array.isArray(state?.list)) return;

            const { updItemId, tasks } = action?.payload || {};
            const item = state.list.find((item) => item.id === updItemId);

            if (!item || !Array.isArray(item.tasks)) return;

            const idsToDelete = new Set(
                []
                    .concat(tasks || [])
                    .filter(Boolean)
                    .map((task) => task.id)
            );

            item.tasks = item.tasks.filter((task) => !idsToDelete.has(task.id));
        }
    }
});

export default slice.reducer;

export const businessOpportunityActions = slice.actions;
